// @generated by protoc-gen-connect-es v0.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.liveQuiz.teacher.apis.proto (package geneo.lms.liveQuiz.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateLiveQuizSessionRequest, CreateLiveQuizSessionResponse, EndLiveQuizQuestionRequest, EndLiveQuizQuestionResponse, EndLiveQuizSessionRequest, EndLiveQuizSessionResponse, GetLiveQuizRosterRequest, GetLiveQuizRosterResponse, GetLiveQuizSessionAnalyticsRequest, GetLiveQuizSessionAnalyticsResponse, GetPreviousLiveQuizSessionsRequest, GetPreviousLiveQuizSessionsResponse, PauseLiveQuizSessionRequest, PauseLiveQuizSessionResponse, StartLiveQuizQuestionRequest, StartLiveQuizQuestionResponse } from "./lms.liveQuiz.teacher.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Teacher-side APIs for the web-based live clicker assessment ("LiveQuiz").
 * LiveQuiz is a thin real-time orchestration layer (session lifecycle, which
 * question is live now) on top of the existing generic assessment pipeline —
 * attempt data (answers/scores) lives on TaskStudentAssignment/
 * StudentHomeworkSession, not on new tables, so results show up in the normal
 * gradebook/reports automatically.
 *
 * @generated from service geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1
 */
export const LmsLiveQuizTeacherAPIServiceV1 = {
  typeName: "geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.createLiveQuizSession
     */
    createLiveQuizSession: {
      name: "createLiveQuizSession",
      I: CreateLiveQuizSessionRequest,
      O: CreateLiveQuizSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.startLiveQuizQuestion
     */
    startLiveQuizQuestion: {
      name: "startLiveQuizQuestion",
      I: StartLiveQuizQuestionRequest,
      O: StartLiveQuizQuestionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.endLiveQuizQuestion
     */
    endLiveQuizQuestion: {
      name: "endLiveQuizQuestion",
      I: EndLiveQuizQuestionRequest,
      O: EndLiveQuizQuestionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.endLiveQuizSession
     */
    endLiveQuizSession: {
      name: "endLiveQuizSession",
      I: EndLiveQuizSessionRequest,
      O: EndLiveQuizSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.getLiveQuizRoster
     */
    getLiveQuizRoster: {
      name: "getLiveQuizRoster",
      I: GetLiveQuizRosterRequest,
      O: GetLiveQuizRosterResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.getLiveQuizSessionAnalytics
     */
    getLiveQuizSessionAnalytics: {
      name: "getLiveQuizSessionAnalytics",
      I: GetLiveQuizSessionAnalyticsRequest,
      O: GetLiveQuizSessionAnalyticsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.getPreviousLiveQuizSessions
     */
    getPreviousLiveQuizSessions: {
      name: "getPreviousLiveQuizSessions",
      I: GetPreviousLiveQuizSessionsRequest,
      O: GetPreviousLiveQuizSessionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.lms.liveQuiz.teacher.apis.LmsLiveQuizTeacherAPIServiceV1.pauseLiveQuizSession
     */
    pauseLiveQuizSession: {
      name: "pauseLiveQuizSession",
      I: PauseLiveQuizSessionRequest,
      O: PauseLiveQuizSessionResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

